import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from "react-select";
import axios from 'axios';
import arrow from "../../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'; 
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs'; 

const CorporateOrderEdit = () => {
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [selectedOption, setSelectedOption] = useState(null);
    const [service_sttm, setServiceSTTMValue] = useState(new DateObject({ hour: 6, minute: 0, meridiem: 'AM' }));
    const [wastageType, setWastageType] = useState("food"); // default is food
    const [showAddOnSection, setShowAddOnSection] = useState(false); // For the Add-On Services section
    const [checkedItems, setCheckedItems] = useState({});
    const [cateringType, setCateringType] = useState({});
    const [functionType, setFunctionType] = useState({});
    const [addOnService, setAddOnService] = useState({});
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [customer, setCustomer] = useState({});
    const [categorizedItems, setCategorizedItems] = useState([]);
    const [items, setItems] = useState({});
    const [selectedService, setSelectedService] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [totalCost, setTotalCost] = useState(0);
    const [vendors, setVendors] = useState();
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst_percentage, setGstPercentage] = useState(0);
    const [confirmCost, setConfirmCost] = useState('');
    const [gstAmount, setGstAmount] = useState(0);
    const [totalWithGst, setTotalWithGst] = useState(0);
    const [itemQuantities, setItemQuantities] = useState({});
    const [coupon, setCoupon] = useState('');
    const [couponId, setCouponId] = useState(null);
    const [couponAmount, setCouponAmount] = useState(0);
    const navigate = useNavigate();
    const [selectedCateringType, setSelectedCateringType] = useState(null);
    const [selectedOrderDate, setSelectedOrderDate] = useState(null);
    const [selectedMealsPeriod, setSelectedMealsPeriod] = useState(null);
    const [selectedFunctionType, setSelectedFunctionType] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [headCount, setHeadCount] = useState('');
    const [specialRequest, setSpecialRequest] = useState('');
    const [paymentClosingDate, setPaymentClosingDate] = useState(null);
    const [advanceAmount, setAdvanceAmount] = useState('');
    const [errors, setErrors] = useState({});
    const [units, setUnits] = useState([]);

    const location = useLocation();
    const { order } = location.state || {};


    const handleQuantityChangeForItem = (itemId, quantity) => {
    setItemQuantities(prev => ({
        ...prev,
        [itemId]: quantity,
    }));
    };

    const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
        return (
            sum +
            group.items.reduce((groupSum, item) => {
            if (checkedItems[item.id]) {
                const quantity = itemQuantities[item.id] || 0;
                const cost = parseFloat(item.cost) || 0;
                return groupSum + cost * quantity;
            }
            return groupSum;
            }, 0)
        );
    }, 0);

    const handleServiceChange = (selectedOption, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                ? {
                    ...item,
                    selectedService: selectedOption,
                    costPerUnit: selectedOption?.cost_per_unit || 0,
                    totalCost: (selectedOption?.cost_per_unit || 0) * item.quantity
                }
                : item
            )
        );
    };

    const handleQuantityChange = (e, index) => {
        const quantity = parseFloat(e.target.value || 0);
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                ? {
                    ...item,
                    quantity,
                    totalCost: quantity * (item.costPerUnit || 0)
                }
                : item
            )
        );
    };

    const handleVendorChange = (selectedVendor, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                ? { ...item, selectedVendor }
                : item
            )
        );
    };

    const fetchCateringType = async () => {
    try {
        const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
        if (response.data && Array.isArray(response.data)) {
            const formatted = response.data.map(item => ({
                value: String(item.sno),
                label: item.catering_type
            }));
            setCateringType(formatted);
        }
    } catch (error) {
        console.error('Failed to fetch Catering Type:', error);
        setCateringType([]);
    }
    };

    const fetchFunctionType = async () => {
    try {
        const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
        if (response.data && Array.isArray(response.data)) {
         const formatted = response.data.map(item => ({
                value: String(item.sno),
                label: item.function_type
            }));
            setFunctionType(formatted);
        }
    } catch (error) {
        console.error('Failed to Function Type:', error);
        setFunctionType({});
    }
    };
    
    const fetchitemSchedule = async () => {
    try {
        const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
        
        const list = response.data?.data;

        if (Array.isArray(list)) {
        const formatted = list.map(item => ({
            value: String(item.sno),
            label: item.itemschedule_name
        }));
        setMealsPeriod(formatted);
        } else {
        setMealsPeriod([]); // fallback to empty array
        }
    } catch (error) {
        console.error('Failed to fetch Meals period:', error);
        setMealsPeriod([]); // fallback to empty array, not object
    }
    };

    const fetchAddOnService = async () => {
    try {
        const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
        if (response.data && Array.isArray(response.data)) {
         const formatted = response.data.map(item => ({
                value: String(item.sno),
                label: item.service,
                vendor: item.vendor,
                cost_per_unit: item.cost_per_unit,
            }));
            setAddOnService(formatted);
        }
    } catch (error) {
        console.error('Failed to Add On Service Type:', error);
        setAddOnService({});
    }
    };

    const fetchCustomer = async (cust_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_customer/get/${cust_id}`);

            if (response.data) {
                setCustomer(response.data);
                console.log(response.data);
            } else {
                console.error('No customer data found for this ID');
                setCustomer(null); // or however you want to handle no data
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
            setCustomer(null); // clear or reset state on error
        }
    };

   const fetchItems = async (scheduleID) => {
    try {
        const response = await axios.get(`${BaseUrl}/manage_corporate_order/get_items_by_schedule/${scheduleID}`);
        if (response.data?.data) {
            setItems(response.data.data);
            setCategorizedItems(response.data.data); // <-- Proper state update
            console.log('Fetched categorized items:', response.data.data);
        } else {
            console.error('No items found for this schedule ID');
            setItems(null); 
            setCategorizedItems([]);
        }
    } catch (error) {
        console.error('Error fetching items:', error);
        setItems(null);
        setCategorizedItems([]);
    }
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchVendors = async (branch_id) => {
    try {
        const response = await axios.get(`${BaseUrl}/manage_corporate_order/get_vendors/${branch_id}`);

        if (response.data?.data) {
            // Map the data to the required format
            const formattedVendors = response.data.data.map(vendor => ({
                value: vendor.sno.toString(),             // or vendor.vendor_id if you want unique string id
                label: vendor.vendor_businessname || 'Unknown Vendor',
            }));

            setVendors(formattedVendors);

            // Optional: console.log to check format
            console.log('Formatted Vendors:', formattedVendors);
        } else {
            console.error('No vendors found for this branch ID');
            toast.error('Not Able to Fetch Vendors');
            setVendors([]);
        }
    } catch (error) {
        console.error('Error fetching vendors:', error);
        setVendors([]);
    }
    };

    const getGST = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setGstPercentage(parseFloat(response.data.data.gst));
                } else {
                    console.log("Unexpected API response structure:", response);
                    setGstPercentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setGstPercentage(5);
            });
    }

    const fetchUnits = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manageunit/list/active`);
            if (response.data && response.data.data) {
            setUnits(response.data.data);  // <-- this is the array you want
            } else {
            setUnits([]);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setUnits([]);
        }
    };

    const getUnitSlugName = (unitId) => {
        if (!unitId) return '';
        const idNum = Number(unitId);
        if (isNaN(idNum)) return '';
        const matchedUnit = units.find(unit => Number(unit.sno) === idNum);
        console.log('Looking for unitId:', idNum);
        console.log('Matched unit:', matchedUnit);
        return matchedUnit ? matchedUnit.unitslug_name : '';
    };

    useEffect(() => {
            const customerId = localStorage.getItem('selectedCustomerId');
            fetchCustomer(customerId);
            fetchAddOnService();
            fetchFunctionType();
            fetchCateringType();
            fetchitemSchedule();
            fetchUnits();
            fetchVendors(branch_id);
            getGST();
    }, []);

    const handleAddOnToggle = (e) => {
        setShowAddOnSection(e.target.checked);
    };

    const handleItemCheckboxChange = (itemId, isChecked) => {
        setCheckedItems((prev) => ({
            ...prev,
            [itemId]: isChecked,
        }));
    };
            
    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);
    
    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };

    const handleConfirmCostChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setConfirmCost(value);
            const costNumber = parseFloat(value) || 0;
            const gst = (costNumber * gst_percentage) / 100;
            setGstAmount(gst);
            setTotalWithGst(costNumber + gst);
        }
    };

    useEffect(() => {
    const costNumber = parseFloat(confirmCost) || 0;
    const gst = (costNumber * gst_percentage) / 100;
    setGstAmount(gst);
    setTotalWithGst(costNumber + gst);
    }, [confirmCost, gst_percentage]);

    
    useEffect(() => {
    const rawMaterialTotal = showAddOnSection
        ? rawMatrial.reduce((sum, item) => sum + (item.totalCost || 0), 0)
        : 0;

    const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
        return (
        sum +
        group.items.reduce((groupSum, item) => {
            if (checkedItems[item.id]) {
            const quantity = itemQuantities[item.id] || 0;
            const cost = parseFloat(item.cost) || 0;
            return groupSum + cost * quantity;
            }
            return groupSum;
        }, 0)
        );
    }, 0);

    setGrandTotal(rawMaterialTotal + checkedItemsTotal);
    }, [rawMatrial, checkedItems, itemQuantities, categorizedItems, showAddOnSection]);

console.log("Checked Items:", checkedItems);
console.log("Item Quantities:", itemQuantities);
console.log("Categorized Items:", categorizedItems);

    const selectedItems = categorizedItems.flatMap(group =>
    group.items
        .filter(item => checkedItems[item.id])
        .map(item => {
        const quantity = itemQuantities[item.id] || 0;
        console.log(`Item ID: ${item.id}, Quantity: ${quantity}`);
        return {
            id: item.id,
            name: item.name,
            quantity: quantity > 0 ? quantity : 1,
            category: group.category,
            sub_category: group.sub_category,
            cost: item.cost || 0,
        };
        })
    );



console.log("Selected Items to Send:", selectedItems);


 const handleApplyClick = () => {
  if (!coupon) {
    toast.error('Coupon Code is Required.');
    return;
  }

  const filter = {
    coupon_code: coupon,
    coupon_for: 1,
  };

  axios.get(`${BaseUrl}/coupon/code`, { params: filter })
    .then(response => {
      const data = response.data.data;
      if (data) {
        setCouponId(data.sno);

        // Parse confirmCost properly
        const parsedCost = parseFloat(confirmCost) || 0;

        // Calculate discount
        let discountValue = 0;
        if (data.coupon_type === 0) {
          // Fixed discount
          discountValue = parseFloat(data.coupon_value);
        } else if (data.coupon_type === 1) {
          // Percentage discount
          const percentage = parseFloat(data.coupon_value);
          discountValue = parsedCost * (percentage / 100);
        }

        // New net amount after discount
        const netAmount = parsedCost - discountValue;

        // Recalculate GST based on net amount
        const gst = netAmount * (gst_percentage / 100);

        // Final grand total
        const grandTotal = netAmount + gst;

        // Set all values
        setCouponAmount(discountValue);
        setGstAmount(gst);
        setTotalWithGst(grandTotal);
      } else {
        setCouponAmount(0);
        toast.error('Coupon not valid or expired');
        setCouponId(null);
      }
    })
    .catch(error => {
      setCouponAmount(0);
      console.error('There was an error fetching the data!', error);
      toast.error('Error fetching coupon. Please try again.');
      setCouponId(null);
    });
};


    // useEffect(() => {
    //     if (coupon) {
    //         handleApplyClick();
    //     }
    // }, [coupon]);

    const validateForm = () => {
        const newErrors = {};
        const today = new Date();
        today.setHours(0, 0, 0, 0); // reset to midnight for date comparison

        // Catering Type required
        if (!selectedCateringType) {
            newErrors.selectedCateringType = "Catering Type is required";
        }

        // Order Date required & can't be before today
        if (!selectedOrderDate) {
            newErrors.selectedOrderDate = "Order Date is required";
        } 
        // Order Time required
        if (!service_sttm) {
            newErrors.service_sttm = "Order Time is required";
        }

        // Meals Period required
        if (!selectedMealsPeriod) {
            newErrors.selectedMealsPeriod = "Meals Period is required";
        }

        if (!selectedFunctionType) {
            newErrors.selectedFunctionType = "Function Type is required";
        }

        if (!deliveryAddress || !deliveryAddress.trim()) {
            newErrors.deliveryAddress = "Delivery Address is required";
        }

        if (!headCount || isNaN(headCount) || Number(headCount) <= 0) {
            newErrors.headCount = "Please enter a valid Head Count (number > 0)";
        }
        if (!paymentClosingDate) {
            newErrors.paymentClosingDate = "Payment Closing Date is required";
        }
        Object.entries(checkedItems).forEach(([itemId, isChecked]) => {
            if (isChecked) {
            const qty = itemQuantities[itemId];
            if (!qty || isNaN(qty) || Number(qty) <= 0) {
                newErrors[`itemQuantity_${itemId}`] = "Please enter valid quantity (>0)";
            }
            }
        });

        // Validate add-on services if visible
        if (showAddOnSection) {
            rawMatrial.forEach((config, idx) => {
            if (!config.selectedService) {
                newErrors[`addOnService_${idx}`] = "Service is required";
            }
            if (config.selectedService && config.selectedService.vendor === 0 && !config.selectedVendor) {
                newErrors[`addOnVendor_${idx}`] = "Vendor is required";
            }
            if (!config.quantity || isNaN(config.quantity) || Number(config.quantity) <= 0) {
                newErrors[`addOnQuantity_${idx}`] = "Enter valid units (>0)";
            }
            if (
                config.totalCost === undefined ||
                config.totalCost === null ||
                isNaN(config.totalCost) ||
                Number(config.totalCost) < 0
            ) {
                newErrors[`addOnCost_${idx}`] = "Enter valid total cost (>= 0)";
            }
            });
        }

        const parsedConfirmCost = parseFloat(confirmCost);

        if (isNaN(parsedConfirmCost) || parsedConfirmCost < 0) {
            newErrors.confirmCost = "Confirm Cost must be a positive number or zero";
        }

        const parsedAdvanceAmount = parseFloat(advanceAmount);

        if (
        advanceAmount === "" ||
        isNaN(parsedAdvanceAmount) ||
        parsedAdvanceAmount < 0
        ) {
        newErrors.advanceAmount = "Advance Amount must be a zero or positive number";
        } else {
        }


        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
    setErrors(null);

    if (!validateForm()) {
        return;
    }

    const addOnServices = showAddOnSection
        ? rawMatrial
              .filter(config => config.selectedService)
              .map(config => ({
                  service: config.selectedService.value,
                  vendor: config.selectedVendor ? config.selectedVendor.value : null,
                  quantity: config.quantity,
                  totalCost: config.totalCost,
              }))
        : [];

    const dataToSend = {
        cateringType: selectedCateringType.value,
        orderDate: new Date(selectedOrderDate).toLocaleDateString('en-CA'),  
        orderTime: new Date(service_sttm).toTimeString().slice(0, 5),          
        mealsPeriod: selectedMealsPeriod.value,
        functionType: selectedFunctionType.value,
        deliveryAddress: deliveryAddress.trim(),
        headCount: Number(headCount),
        specialRequest: specialRequest.trim(),
        paymentClosingDate: new Date(paymentClosingDate).toLocaleDateString('en-CA'), 
        addOnService: addOnServices,
        items: selectedItems,
        advanceAmount: Number(advanceAmount),
        confirmCost: Number(confirmCost),
        coupon: coupon,
        branch_id: branch_id,
        customer_id: customer.sno,
        total: totalWithGst,
        gst: gstAmount,
        couponamount: couponAmount,
    };


    console.log("Prepared data to send:", JSON.stringify(dataToSend, null, 2));

    try {
        const user_id = parseInt(localStorage.getItem("user_id"), 10);

        if (!order || !order.id) {
            toast.error('Order ID is missing. Cannot update.');
            return;
        }

        // Change POST to PUT and include order id in URL
        const response = await fetch(`${BaseUrl}/manage_corporate_order/update_order/${order.id}/${user_id}`, {
            method: 'PUT', // or 'PATCH' if partial update
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        });

        if (!response.ok) {
            const errorData = await response.json();
            toast.error('Failed to update order');
            console.error('Update error:', errorData);
            return;
        }

        const result = await response.json();
        toast.success('Order updated successfully!');
        navigate('/manage-corporate-order');
    } catch (error) {
        setErrors(error.message);
        toast.error('Error updating order. Please try again.');
    }
    };


useEffect(() => {
  if (!order) return;

  // Only proceed if addOnService and vendors options are loaded
   if (!Array.isArray(addOnService) || addOnService.length === 0) return;
  if (!Array.isArray(vendors) || vendors.length === 0) return;

    let parsedAddOnService = [];
    try {
    if (typeof order.addonservice === 'string') {
        parsedAddOnService = JSON.parse(order.addonservice || '[]');
    } else if (Array.isArray(order.addonservice)) {
        parsedAddOnService = order.addonservice;
    }
    } catch (e) {
    console.error("Invalid addonservice JSON:", e);
    }

const mappedRawMatrial = parsedAddOnService.map((item, idx) => {
  const selectedService = addOnService.find(s => String(s.value) === String(item.service)) || null;
  const selectedVendor = selectedService?.vendor === 0
    ? vendors.find(v => String(v.value) === String(item.vendor)) || null
    : null;

  return {
    id: idx + 1,
    selectedService,
    selectedVendor,
    quantity: item.quantity,
    totalCost: item.totalCost,
    costPerUnit: selectedService ? parseFloat(selectedService.cost) || 0 : 0,  // set cost per unit here
  };
});

  setRawMatrial(mappedRawMatrial);
  setShowAddOnSection(mappedRawMatrial.length > 0);

    let parsedItems = [];
    try {
    if (typeof order.items === 'string') {
        parsedItems = JSON.parse(order.items || '[]');
    } else if (Array.isArray(order.items)) {
        parsedItems = order.items;
    }
    setItems(parsedItems);

    const initialCheckedItems = {};
    const initialQuantities = {};
    parsedItems.forEach(item => {
        initialCheckedItems[item.id] = true;
        initialQuantities[item.id] = item.quantity || 0;
    });
    setCheckedItems(initialCheckedItems);
    setItemQuantities(initialQuantities);
    } catch (e) {
    console.error("Failed to parse items", e);
    }


  setCustomer(order.customer || {});
  setConfirmCost(order.confirm_cost || '');
  setAdvanceAmount(order.advance_amount || '');
  setDeliveryAddress(order.delivery_address || '');
  setHeadCount(order.head_count || '');
  setSpecialRequest(order.special_request || '');
  setCoupon(order.coupon || '');
  

  if (cateringType.length) {
    const selected = cateringType.find(opt => String(opt.value) === String(order.catering_type));
    setSelectedCateringType(selected || null);
  }
  if (functionType.length) {
    const selected = functionType.find(opt => String(opt.value) === String(order.function_type));
    setSelectedFunctionType(selected || null);
  }
  if (mealsPeriod.length) {
    const selected = mealsPeriod.find(opt => String(opt.value) === String(order.meals_period));
    setSelectedMealsPeriod(selected || null);
    fetchItems(order.meals_period);
  }

  setSelectedOrderDate(order.order_date ? new DateObject(order.order_date) : null);
  setPaymentClosingDate(order.payment_closing_date ? new DateObject(order.payment_closing_date) : null);
  setServiceSTTMValue(((t) => { const d = new Date(); [d.setHours, d.setMinutes, d.setSeconds].forEach((fn, i) => fn.call(d, t.split(':')[i] || 0)); return d; })(order.order_time));


  setGrandTotal(Number(order.total) || 0);
  setGstPercentage(Number(order.gst_percentage) || 0);
  setGstAmount(Number(order.gst_amount) || 0);
  setTotalWithGst(Number(order.total_with_gst) || 0);

}, [order, addOnService, vendors, cateringType, functionType, mealsPeriod]);



    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Corporate Order</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Corporate Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Corporate Order</li>
                    </ol>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
                     {customer ? (
                    <div className="d-flex flex-column">
                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Basmathi Rice</span></Tooltip>} >
                            <label className='text-danger font-w500 fs-5 text-truncate w-150px'>{customer.customer_name}</label>
                        </OverlayTrigger>
                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Brand/Quantity</span></Tooltip>} >
                            <label className='text-black font-w400 fs-7'>{customer.customer_number}</label>
                        </OverlayTrigger>
                    </div>
                     ) : ( <div></div> ) }
                </div>
            </div>
            <div className='row mb-2'>
                <h4 className='font-w600 text-black'>Order Details</h4>
               <div className="col-lg-3 mb-4">
                <label className="text-black font-w500 fs-7">
                    Catering Type<span className="required">*</span>
                </label>

                {/* Readonly display */}
                <div 
                    className="form-control" 
                    style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                    readOnly
                >
                    {selectedCateringType ? selectedCateringType.label : 'No Catering Type selected'}
                </div>

                {errors.selectedCateringType && (
                    <small className="text-danger">{errors.selectedCateringType}</small>
                )}
                </div>

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Order Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={selectedOrderDate}
                            onChange={setSelectedOrderDate}
                            format="DD-MM-YYYY"
                            disabled
                        />
                        </div>
                         {errors.selectedOrderDate && (
                            <small className="text-danger">{errors.selectedOrderDate}</small>
                        )}
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Order Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                            <i className='fa-solid fa-clock fs-4'></i>
                        </div>
                        <DatePicker placeholder='Select Time'
                            disableDayPicker
                            value={service_sttm}
                            onChange={setServiceSTTMValue}
                            format="HH:mm"
                            plugins={[
                                <TimePicker hideSeconds />
                            ]}
                        />
                    </div>
                    {errors.service_sttm && (
                        <small className="text-danger">{errors.service_sttm}</small>
                    )}
                </div>
              <div className="col-lg-3 mb-4">
                <label className="text-black font-w500 fs-7">
                    Meals Period<span className="required">*</span>
                </label>

                {/* Readonly display */}
                <div
                    className="form-control"
                    style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                    readOnly
                >
                    {selectedMealsPeriod ? selectedMealsPeriod.label : 'No Meals Period selected'}
                </div>

                {errors.selectedMealsPeriod && (
                    <small className="text-danger">{errors.selectedMealsPeriod}</small>
                )}
                </div>
              <div className="col-lg-3 mb-4">
                <label className="text-black font-w500 fs-7">
                    Function Type<span className="required">*</span>
                </label>

                {/* Readonly display */}
                <div
                    className="form-control"
                    style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                    readOnly
                >
                    {selectedFunctionType ? selectedFunctionType.label : 'No Function Type selected'}
                </div>

                {errors.selectedFunctionType && (
                    <small className="text-danger">{errors.selectedFunctionType}</small>
                )}
                </div>

                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Delivery Address<span className="required">*</span></label>
                    <textarea className="form-control" placeholder="Enter Delivery Address" value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} />
                    {errors.deliveryAddress && (
                        <small className="text-danger">{errors.deliveryAddress}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Head Count (in No's)<span className="required">*</span></label>
                    <input type="number" className="form-control" placeholder="Enter Head Count" value={headCount} onChange={e => setHeadCount(e.target.value)} />
                    {errors.headCount && (
                        <small className="text-danger">{errors.headCount}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Special Request (if Any)</label>
                    <textarea className="form-control"  value={specialRequest} onChange={e => setSpecialRequest(e.target.value)} placeholder="Enter Special Request" />
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Payment Closing Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={paymentClosingDate}
                            onChange={setPaymentClosingDate}
                            format="DD-MM-YYYY"
                            readOnly
                            disabled
                        />
                    </div>
                    {errors.paymentClosingDate && (
                        <small className="text-danger">{errors.paymentClosingDate}</small>
                    )}
                </div>
            </div>
          
            {categorizedItems.map((group, index) => (
                <div className="mb-4" key={index}>
                <label className="fs-6 text-primary mb-1 font-w600">{group.category} - {group.sub_category}</label>
                
                <div className="row">
                    {group.items.map((item) => (
                    <div className="col-lg-3" key={item.id}>
                        <div className="form-check-inline mt-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`item-${item.id}`}
                            checked={!!checkedItems[item.id]}
                            onChange={(e) => handleItemCheckboxChange(item.id, e.target.checked)}
                        />
                        <label className="fs-7 text-black mb-0 font-w500" htmlFor={`item-${item.id}`}>
                            {item.name} <span className="fs-9">({getUnitSlugName(item.measurement_quantity)})</span>
                        </label>
                        </div>

                        {checkedItems[item.id] && (
                        <div className="mt-2">
                            <input
                            type="number"
                            className="form-control"
                            placeholder={`Enter quantity for ${item.name}`}
                            value={itemQuantities[item.id] || ''}
                            onChange={(e) => handleQuantityChangeForItem(item.id, Number(e.target.value))}
                            min={0}
                            />
                            {errors[`itemQuantity_${item.id}`] && (
                            <small className="text-danger">{errors[`itemQuantity_${item.id}`]}</small>
                            )}
                        </div>
                        )}
                    </div>
                    ))}
                </div>
                </div>
            ))}
            <div className='row mb-2'>
                <div className='col-lg-12 mb-2'>
                    <div className="form-check custom-checkbox mt-3">
                        <input
                            type="checkbox"
                            onChange={handleAddOnToggle}
                            className="form-check-input me-3"
                            id="customCheckBox1"
                            checked={showAddOnSection}
                            
                        />
                        <h4 className='font-w600 text-black' htmlFor="customCheckBox1">Add-On Services</h4>
                    </div>
                </div>
                {showAddOnSection && (
                    <>
                        {rawMatrial.map((config, index) => (
                            <div key={config.id} data-repeater-item>
                                <div className='row mb-2'>
                                    <div className='col-lg-11'>
                                        <div className='row'>
                                            <div className='col-lg-3 mb-2'>
                                                <label className="text-black font-w500 fs-7">Service<span className="required">*</span></label>
                                                <Select 
                                                    placeholder='Select Service'
                                                    value={config.selectedService}
                                                    onChange={(option) => handleServiceChange(option, index)}
                                                    options={addOnService}
                                                />
                                                {errors[`addOnService_${index}`] && (
                                                    <small className="text-danger">{errors[`addOnService_${index}`]}</small>
                                                )}
                                            </div>

                                            {config.selectedService?.vendor === 0 && (
                                                <div className='col-lg-3 mb-2'>
                                                    <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                                                    <Select 
                                                        placeholder='Select Vendor'
                                                        value={config.selectedVendor}
                                                        onChange={(option) => handleVendorChange(option, index)}
                                                        options={vendors}
                                                    />
                                                    {errors[`addOnVendor_${index}`] && (
                                                        <small className="text-danger">{errors[`addOnVendor_${index}`]}</small>
                                                    )}
                                                </div>
                                            )}

                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">No Of Units<span className="required">*</span></label>
                                                <input 
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Units"
                                                    value={config.quantity}
                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                />
                                                {errors[`addOnQuantity_${index}`] && (
                                                <small className="text-danger">{errors[`addOnQuantity_${index}`]}</small>
                                                )}
                                            </div>

                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Total Cost<span className="required"></span></label>
                                                <input 
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Total Cost"
                                                    value={(config.totalCost || 0).toFixed(2)}
                                                    readOnly
                                                    disabled
                                                />
                                                 {errors[`addOnCost_${index}`] && (
                                                <small className="text-danger">{errors[`addOnCost_${index}`]}</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-1 mb-1 px-1 py-1">
                                        {rawMatrial.length > 1 && (
                                            <button
                                                className="btn btn-danger mt-4 px-2 py-2"
                                                onClick={() => handleDeleteConfig(config.id)}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                            >
                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                      
                        <div className="mb-1 mt-1">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddConfig}
                            >
                                <span><i className="fa-solid fa-plus fs-6"></i></span>
                                <span className='ms-2 fs-7'>Add More</span>
                            </button>
                        </div>
                    </>
                 )}
            </div>
            <div className='row mx-2 my-2'>
                {/* <h4 className='font-w600 text-black'>Order Payment</h4> */}
                <div className='d-flex flex-column align-items-end justify-content-end py-4 px-4 rounded' style={{backgroundColor:'#f0f5ef'}}>
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-black font-w500 fs-5">Total Cost<span className="required"></span></label>
                            <input type="text" className="form-control" placeholder="Enter Total Cost" style={{width: '50%'}} readonly disabled value={grandTotal.toFixed(2)}  />
                        </div>
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-black font-w500 fs-5">Confirm Cost<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Confirm Cost" style={{width: '50%'}} value={confirmCost} onChange={handleConfirmCostChange} />
                        </div>
                             {errors.confirmCost && (
                                <small className="text-danger">{errors.confirmCost}</small>
                            )}
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-black font-w500 fs-5">Advance Amount<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Advance Amount" style={{width: '50%'}} value={advanceAmount} onChange={e => setAdvanceAmount(e.target.value)}/>
                        </div>
                        {errors.advanceAmount && (
                                <small className="text-danger">{errors.advanceAmount}</small>
                            )}
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-black font-w500 fs-5">
                                Discount Coupon<span className="required"></span>
                            </label>
                             <div className="d-flex gap-2 w-50">
                                <input type="text"className="form-control"placeholder="Enter Coupon" style={{ flex: 1 ,width:'5%' }} value={coupon}  onChange={e => setCoupon(e.target.value)} />
                                <button type="button"className="btn btn-sm btn-primary"style={{ whiteSpace: 'nowrap' }}><img src={arrow} alt='submit' onClick={handleApplyClick}  /></button>
                            </div>
                        </div>
                    </div>
                   {couponAmount ? (
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                        <label className="text-black font-w500 fs-5">
                            Coupon Amount
                            <span className="required"></span>
                        </label>
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Enter GST Amount" 
                            style={{width: '50%'}} 
                            value={couponAmount.toFixed(2)} 
                            readOnly 
                        />
                        </div>
                    </div>
                    ) : null}


                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-black font-w500 fs-5">GST Amount<span className="required"></span>
                            <span className='d-block'>({gst_percentage}%)</span></label>
                            <input type="text" className="form-control" placeholder="Enter GST Amount" style={{width: '50%'}} value={gstAmount.toFixed(2)} readOnly/>
                        </div>
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                            <label className="text-danger font-w500 fs-4">Grand Total<span className="required"></span></label>
                            <input type="text" className="form-control" placeholder="Enter Grand Total" style={{width: '50%'}} readonly value={totalWithGst.toFixed(2)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                    Edit Order
                    <i className="fas fa-angle-double-right ms-2"></i>
                </button>
            </div>

        </>
    )


}
export default CorporateOrderEdit;